import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseurl } from '../../helper/Baseurl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';
import { useTranslation } from "../../context/TranslationContext"; 
import NoBooksMessage from '../../component/Book/NoBooksMessage';
import BorrowModal from '../../component/Borrow/BorrowModal';
import BorrowList from '../../component/Borrow/BorrowList';
import SearchAndSortBar from "../../component/SearchAndSortBar"; 
import Pagination from '../../component/Pagination';

    export default function AllBorrowsbooks() {
        const { translations , language} = useTranslation(); 
        const isArabic = language === "ar";
      
        const navigate = useNavigate();
        const [books, setBooks] = useState([]);
        const [likedBooks, setLikedBooks] = useState({});
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [borrowDate, setBorrowDate] = useState('');
        const [returnDate, setReturnDate] = useState('');
        const [selectedBook, setSelectedBook] = useState(null);
        const [loading, setLoading] = useState(true); 
        const [sortOption, setSortOption] = useState("فرز حسب");
        const [searchTerm, setSearchTerm] = useState("");
        const [filteredBooks, setFilteredBooks] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const booksPerPage = 8;
        const indexOfLastBook = currentPage * booksPerPage;
        const indexOfFirstBook = indexOfLastBook - booksPerPage;
        const currentCourses = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
        const totalPages = Math.ceil(filteredBooks.length / booksPerPage);
      
        const handleLikeClick = async (id) => {
          try {
            const response = await axios.post(
              `${baseurl}toggle-favorite`,
              {
                type: "BOOK",
                id: id,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              }
            );
      
            if (response.data.isFavorite !== undefined) {
              setLikedBooks((prev) => ({
                ...prev,
                [id]: response.data.isFavorite,
              }));
            }
          } catch (error) {
            console.error("Error toggling favorite:", error);
          }
        };
        const bookAvailabilityTranslations = {
            AVAILABLE_BOTH: "متاح",
            AVAILABLE_LIBRARY_ONLY: "متاح بالمكتبة",
            AVAILABLE_ONLINE_ONLY: "متاح بالإنترنت",
            RESERVED: "محجوز",
            UNAVAILABLE: "غير متاح",
          };
          
          useEffect(() => {
            const fetchBooks = async () => {
              try {
                const response = await axios.get(baseurl + "all-books", {
                  headers: {
                    accept: "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                });
                const filteredBooksData = response.data.filter(
                  (book) => book.bookAvailability === " AVAILABLE_LIBRARY_ONLY" || book.bookAvailability === "AVAILABLE_BOTH"|| book.bookAvailability === "RESERVED"|| book.bookAvailability === "UNAVAILABLE"
                );
          
                const booksData = await Promise.all(
                  filteredBooksData.map(async (book) => {
                    const imageUrl = await showpicbooks(book.coverImageUrl);
                    return { 
                      ...book, 
                      imageUrl,
                      availabilityText: bookAvailabilityTranslations[book.bookAvailability] || "غير معروف"
                    };
                  })
                );
          
                const initialLikedBooks = {};
                booksData.forEach((book) => {
                  initialLikedBooks[book.id] = book.isFavorite;
                });
          
                setBooks(booksData);
                setFilteredBooks(booksData);
                setLikedBooks(initialLikedBooks);
              } catch (error) {
                console.error("Error fetching books:", error);
              } finally {
                setLoading(false);
              }
            };
          
            fetchBooks();
          }, []);
          
          const showpicbooks = async (fileName) => {
            try {
              const imageUrl = `${baseurl}uploads/file/download/${fileName}`;
              console.log("Fetched image URL:", imageUrl);
              return imageUrl;
            } catch (error) {
              console.error("Error fetching image:", error);
              return null;
            }
          };
        
          const handleSortChange = (e) => {
            setSortOption(e.target.value);
          };
        
          useEffect(() => {
            let sortedBooks = [...filteredBooks];
            if (sortOption === "الأحدث") {
              sortedBooks.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            } else if (sortOption === "الأعلى تقييمًا") {
              sortedBooks.sort((a, b) => b.rating - a.rating);
            }
            setFilteredBooks(sortedBooks);
          }, [sortOption]);
        
          useEffect(() => {
            const searchQuery = searchTerm.toLowerCase();
            const filtered = books.filter((book) =>
              book.title.toLowerCase().includes(searchQuery) ||
              book.publisher.toLowerCase().includes(searchQuery)
            );
            setFilteredBooks(filtered);
          }, [searchTerm, books]);
        
          const handlePageChange = (pageNumber) => {
            setCurrentPage(pageNumber);
          };
        
          const openBookDetails = (bookId) => {
            navigate(`/BookDetails/${bookId}`);
          };
        
          const openBorrowModal = (bookId) => {
            setBorrowDate(new Date().toISOString().split('T')[0]); 
            setReturnDate('');
            setSelectedBook(bookId);
            setIsModalOpen(true);
          };
        
          const closeModal = () => {
            setIsModalOpen(false);
          };
        
          const [loading1, setLoading1] = useState(false);
        
          const handleSaveBorrow = () => {
            if (!selectedBook || !borrowDate || !returnDate) {
              toast.warning(translations.warningFillAllFields);
              return;
            }
        
            const borrowData = {
              bookId: selectedBook,
              collectDate: new Date(borrowDate).toISOString(),
              returnDate: new Date(returnDate).toISOString(),
            };
        
            setLoading1(true);
        
            axios
              .post(baseurl + 'request-book-borrow', borrowData, {
                headers: {
                  'accept': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
              })
              .then((response) => {
                toast.success(translations.borrowRequestSuccess);
                setLoading1(false);
                setIsModalOpen(false);
                setTimeout(() => {
                  closeModal(); 
                }, 3000);
              })
              .catch((error) => {
                toast.warning(translations.borrowRequestError);
                setLoading1(false);
              });
          };
        
          const getAvailabilityStyle = (availability) => {
            switch (availability) {
              case 'AVAILABLE_BOTH':
                return { text: translations.available, bgColor: 'bg-green-600', btnText: translations.buy_now, btnDisabled: false };
              case 'AVAILABLE_LIBRARY_ONLY':
                return { text: translations.available_library_only, bgColor: 'bg-blue-500', btnText:translations.borrow_now, btnDisabled: false };
              case 'AVAILABLE_ONLINE_ONLY':
                return { text: translations.available_online_only, bgColor: 'bg-blue-500', btnText: translations.buy_now, btnDisabled: false };
              case 'RESERVED':
                return { text: translations.reserved, bgColor: 'bg-yellow-500', btnText:translations.borrow_now, btnDisabled: true };
              case 'UNAVAILABLE':
                return { text: translations.unavailable, bgColor: 'bg-red-500', btnText: translations.buy_now, btnDisabled: true };
              default:
                return { text: '', bgColor: '', btnText: '', btnDisabled: true };
            }
          };
        
      return (
        <>
        {loading ? (
          <div className="flex items-center justify-center h-screen">
            <FaSpinner className="text-4xl animate-spin" />
          </div>
        ) : books.length === 0 ? (
          <NoBooksMessage translations={translations} />
        ) : (
          <div>
            <SearchAndSortBar
              searchTerm={searchTerm}
              handleSearchChange={(e) => setSearchTerm(e.target.value)}
              sortOption={sortOption}
              handleSortChange={handleSortChange}
              translations={translations}
            />
      
            <BorrowList
              books={currentCourses}
              likedBooks={likedBooks}
              handleLikeClick={handleLikeClick}
              openBorrowModal={openBorrowModal}
              getAvailabilityStyle={getAvailabilityStyle}
              translations={translations}
            />
      
            <div className="mt-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
                isArabic={isArabic}
              />
            </div>
      
            <BorrowModal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            borrowDate={borrowDate}
            returnDate={returnDate}
            setReturnDate={setReturnDate}
            handleSaveBorrow={handleSaveBorrow}
            loading={loading1}
          />

      
            <ToastContainer />
          </div>
        )}
      </>
      )
    }
    